import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import $ from 'jquery';
import { API_DOMAIN } from './globals'; // Import the global domain name

function MatkaBet() {

    const [UserType, setUserType] = useState("");
    const [UserName, setUserName] = useState("");

    const { LID, LN, OBT, CBT, AN, RN } = useParams();

    //console.log(LID + ", " + LN + ", " + OBT + ", " + CBT);

    const Single = Array.from({ length: 10 }, (_, index) => index);
    const Jodi = Array.from({ length: 100 }, (_, index) => index);

    const [lotteryBets, setlotteryBets] = useState([]);
    
    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    const [inputValue, setInputValue] = useState("");
    let i=0;

    const formatDateWithDashes = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value); // Update state with the new input value
    };

    function ShowHideBet(Type) {
        if (Type == "SinglePatti") {
            $("#SinglePatti").css("display", "flex");
            $("#HarupAB").css("display", "none");
        } else {
            $("#SinglePatti").css("display", "none");
            $("#HarupAB").css("display", "flex");
        }
        $("#BetTypeWithNum").html("");
        $("#BetTypeWithNumMob").html("");
    }

    function ShowBetSlipBox(Type, Num) {
        var $window = $(window);
        var windowsize = $window.width();
        //console.log(windowsize);
        if (windowsize >= 500) {
            $("#betSlipBox").css("display", "block");
            if (Type == "Single Patti") {
                if ($("#BetTypeWithNum").html() == "")
                    $("#BetTypeWithNum").html("Single, " + Num);
                else
                    $("#BetTypeWithNum").html($("#BetTypeWithNum").html() + ", " + Num);
            } else if (Type == "Harup Andar") {
                if ($("#BetTypeWithNum").html() == "")
                    $("#BetTypeWithNum").html("ANDAR, " + Num);
                else
                    $("#BetTypeWithNum").html($("#BetTypeWithNum").html() + ", " + Num);
            } else if (Type == "Harup Bahar") {
                if ($("#BetTypeWithNum").html() == "")
                    $("#BetTypeWithNum").html("BAHAR, " + Num);
                else
                    $("#BetTypeWithNum").html($("#BetTypeWithNum").html() + ", " + Num);
            }

            $("#BetType").val(Type);
            $("#BetNo").val(Num);
        } else {
            $("#betSlipBoxMob").css("display", "block");

            if (Type == "Single Patti") {
                if ($("#BetTypeWithNumMob").html() == "")
                    $("#BetTypeWithNumMob").html("Single, " + Num);
                else
                    $("#BetTypeWithNumMob").html($("#BetTypeWithNumMob").html() + ", " + Num);
            } else if (Type == "Harup Andar") {
                if ($("#BetTypeWithNumMob").html() == "")
                    $("#BetTypeWithNumMob").html("ANDAR, " + Num);
                else
                    $("#BetTypeWithNumMob").html($("#BetTypeWithNumMob").html() + ", " + Num);
            } else if (Type == "Harup Bahar") {
                if ($("#BetTypeWithNumMob").html() == "")
                    $("#BetTypeWithNumMob").html("BAHAR, " + Num);
                else
                    $("#BetTypeWithNumMob").html($("#BetTypeWithNumMob").html() + ", " + Num);
            }

            $("#BetTypeMob").val(Type);
            $("#BetNoMob").val(Num);
        }
    }
    
    const ResetBet = () => {
		$("#BetTypeWithNum").html("");
		$("#BetTypeWithNumMob").html("");
		// $("#SingleNumber").css("display","none");
		// $("#Jodi").css("display","none");
		// $("#Patti").css("display","none");
	};

	const BackBet = () => {
		var $window = $(window);
		var windowsize = $window.width();

		//var Number = new Array();

		var Number={};
		if(windowsize>=500)
			Number=$("#BetTypeWithNum").html();
		else
			Number=$("#BetTypeWithNumMob").html();

		var Num=Number.split(', ');

		Num.pop();

		Number="";

		for(i=0;i<Num.length;i++) {
			Number+=Num[i]+", ";
		}

		if(windowsize>=500)
			$("#BetTypeWithNum").html(Number.substring(0,Number.length-2));
		else
			$("#BetTypeWithNumMob").html(Number.substring(0,Number.length-2));
	};

    const handlePlaceBet = () => {
        PlaceLotteryBet();
    };

    function PlaceLotteryBet() {
        document.getElementById("cmdDone").disabled = true;

        const userType = document.getElementById("UserType").value;
        const userName = document.getElementById("UserName").value;
        
        // Get window size
        var windowSize = window.innerWidth;

        // Get BetAmount, BetType, BetNo based on window size
        var BetAmount, BetType, BetNo;
        if (windowSize >= 500) {
            BetAmount = parseFloat(document.getElementById("LotteryAmount").value);
            BetType = document.getElementById("BetType").value;
            BetNo = document.getElementById("BetTypeWithNum").innerHTML;
        } else {
            BetAmount = parseFloat(document.getElementById("LotteryAmountMob").value);
            BetType = document.getElementById("BetTypeMob").value;
            BetNo = document.getElementById("BetTypeWithNumMob").innerHTML;
        }

        // Get lottery min and max amounts
        var LotteryMinAmount = parseFloat(document.getElementById("LotteryMinAmount").value);
        var LotteryMaxAmount = parseFloat(document.getElementById("LotteryMaxAmount").value);
        var NotificationType = "Lottery Bet";

        //console.log("BetAmount=" + BetAmount + ", LotteryMinAmount=" + LotteryMinAmount + ", LotteryMaxAmount=" + LotteryMaxAmount);

        if (!isNaN(BetAmount)) {
            if (BetAmount >= LotteryMinAmount && BetAmount <= LotteryMaxAmount) {
                // Construct URL for API call
                var url = "PlaceLotteryBet.php?LotteryID=" + LID +
                    "&BetAmount=" + BetAmount +
                    "&BetType=" + BetType +
                    "&BetNo=" + BetNo +
                    "&ut=" + userType +
                    "&un=" + userName;

                var url = `${API_DOMAIN}/PlaceLotteryBet.php`;

                // Make API call using fetch
                fetch(url, {
                    method: 'POST',
                    credentials: 'include', // Equivalent to withCredentials:true
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        LotteryID: LID,
                        BetAmount: BetAmount,
                        BetType: BetType,
                        BetNo: BetNo,
                        ut: userType,
                        un: userName
                    })
                })
                    .then(res => res.json())
                    .then(res => {
                        //console.log(res.BetDetails[0].Lottery_Bets);
                        var Response = "";

                        if (res.Status === "Success") {
                            // Update UI with response data
                            document.getElementById("TotalCoins").innerHTML = res.TotalCoins - res.UsedCoins;
                            document.getElementById("UsedCoins").innerHTML = Math.round(res.UsedCoins);
                            
                            document.getElementById("TotalCoinsMob").innerHTML = res.TotalCoins - res.UsedCoins;
                            document.getElementById("UsedCoinsMob").innerHTML = Math.round(res.UsedCoins);

                            sessionStorage.setItem('Coins', res.TotalCoins);
                            sessionStorage.setItem('Exposure', res.UsedCoins);
                            
                            // Update bet details and summary
                            setlotteryBets(res.BetDetails[0].Lottery_Bets);

                            //Lottery_Bets_Summary = res.BetDetails[1].Lottery_Bets_Summary;
                            //TotalMBets = LotteryBets.length;
                            //LotteryBetShow = true;

                            Response = '<div class="component-message-wrap" style="animation-duration: 3000ms"><div class="message-content success"><i class="component-icon-wrap icon-success"></i><p>Bet Successful</p></div></div>';
                            document.getElementById("cmdDone").disabled = false;
                        } else if (res.LogoutStat === "Yes") {
                            window.location = '/';
                        } else {
                            Response = '<div class="component-message-wrap" style="animation-duration: 5000ms"><div class="message-content error"><i class="component-icon-wrap icon-error"></i><p>' + res.Message + '</p></div></div>';
                            document.getElementById("cmdDone").disabled = false;
                            document.getElementById("LotteryAmount").readOnly = false;
                        }

                        document.getElementById("BetResponse").innerHTML = Response;
                        document.getElementById("betSlipBox").style.display = 'none';
                        document.getElementById("betSlipBoxMob").style.display = 'none';

                        $("#BetTypeWithNum").html("");
                        $("#BetTypeWithNumMob").html("");
                        
                        setTimeout(function () {
                            document.getElementById("BetResponse").innerHTML = "";
                        }, 3000);
                    });
            } else if (BetAmount < LotteryMinAmount) {
                var Response = '<div class="component-message-wrap" style="animation-duration: 5000ms"><div class="message-content error"><i class="component-icon-wrap icon-error"></i><p>Minimum Bet Amount is ' + LotteryMinAmount + '</p></div></div>';
                document.getElementById("BetResponse").innerHTML = Response;
                setTimeout(function () {
                    document.getElementById("BetResponse").innerHTML = "";
                }, 3000);
                document.getElementById("cmdDone").disabled = false;
                document.getElementById("LotteryAmount").readOnly = false;
            } else if (BetAmount > LotteryMaxAmount) {
                var Response = '<div class="component-message-wrap" style="animation-duration: 5000ms"><div class="message-content error"><i class="component-icon-wrap icon-error"></i><p>Maximum Bet Amount is ' + LotteryMaxAmount + '</p></div></div>';
                document.getElementById("BetResponse").innerHTML = Response;
                setTimeout(function () {
                    document.getElementById("BetResponse").innerHTML = "";
                }, 3000);
                document.getElementById("cmdDone").disabled = false;
                document.getElementById("LotteryAmount").readOnly = false;
            }
        } else {
            document.getElementById("bet-response-body").innerHTML = '<h3 class="text-danger text-center"><svg class="svg-inline--fa fa-times-circle fa-w-16" style="height:30px;width:30px;" aria-hidden="true" data-prefix="fa" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg><br>Invalid Amount ' + BetAmount + '</h3>';
            document.getElementById("deskBetSlip").style.display = 'none';
            document.getElementById("message_error").innerHTML = 'Invalid Amount ' + BetAmount;
            document.getElementById("toast-container_error").modal("show");
            setTimeout(function () {
                document.getElementById("toast-container_error").modal('hide');
            }, 1000);
            document.querySelector(".loader").style.display = 'none';
            document.getElementById("LotteryAmount").readOnly = false;
        }
    }

    useEffect(() => {

        setUserType(sessionStorage.getItem("UserType"));
        setUserName(sessionStorage.getItem("UserName"));

        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2, lid: AN+"_"+LN, ltp: RN, ln: LN };

        const queryString = new URLSearchParams(params).toString();
        //const url = `${API_DOMAIN}/api/Client/getLotteryBetsByClient.php?${queryString}`;
        const url = `${API_DOMAIN}/api/Client/getLotteryBetsByClient.php?${queryString}`;

        //console.log(`url=`+url);
        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            if(data.Status=="Error") {
                sessionStorage.setItem("LogoutMsg",data.Message)
                window.location = '/';
            } else {
                //console.log(data);
                setlotteryBets(data[0].Lottery_Bets);
                //console.log(lotteryBets);
            }
            setLoading(false); // Set loading to false

        })
        .catch(err => {
            setError(err); // Save any error to the state
            setLoading(false); // Set loading to false
        });

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    //if (loading) return <p>Loading...</p>;
    //if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="match-content">
                <div className="">

                    <div className="match-box" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                        <div className="mod-header">
                            <div className="select-tv-ico">
                                <span>Satta (Single Round)</span>
                                <span style={{ float: 'right' }}></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="mod-header tab_bets betsheading matka-block" style={{ display: 'block', backgroundColor: 'rgb(49, 116, 94)' }}>
                            <ul className="nav nav-pills mb-1" id="pills-tab" role="tablist">
                                <li className="nav-item betdata active" style={{ width: '50%', textAlign: 'center', marginTop: '5px', fontSize: '16px' }}>
                                    <a className="allbet" onClick={() => ShowHideBet('SinglePatti')}>
                                        <span className="bet-label">Single Patti</span>
                                        <span className="bat_counter"></span>
                                    </a>
                                </li>
                                <li className="nav-item betdata" style={{ width: '50%', textAlign: 'center', marginTop: '5px', fontSize: '16px' }}>
                                    <a className="unmatchbet" onClick={() => ShowHideBet('HarupAB')}>
                                        <span className="bet-label">Harup Andar Bahar</span>
                                        <span className="bat_counter"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="card single-match text-center my-2">
                            <h5 style={{ textTransform: 'uppercase' }}>{LN}-{formatDateWithDashes(new Date())}</h5>
                            <h6 style={{ textAlign: 'center' }} className="bold">Open Time : {OBT} | Close Time: {CBT}</h6>
                            <div className="row" style={{ margin: '10px', display: 'none' }} id="SinglePatti">
                                <h5 className="col-12 col-md-12 mb-2 " style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>Single Patti</h5>
                                {Jodi.map((num) => (
                                    <div className="col-4 col-md-3 mb-2">
                                        <button className="btn btn-info" style={{ width: '100%' }} onClick={() => ShowBetSlipBox('Single Patti', `${num < 10 ? `0${num}` : num}`)}>
                                            {num < 10 ? `0${num}` : num}
                                        </button>
                                        <span className="btn" style={{ width: '100%' }}></span>
                                    </div>
                                ))}
                            </div>

                            <div className="row" style={{ margin: '10px', display: 'none' }} id="HarupAB">
                                <h5 className="col-12 col-md-12 mb-2 " style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>Harup Andar</h5>
                                {Single.map((num) => (
                                    <div className="col-4 col-md-3 mb-2">
                                        <button className="btn btn-info" style={{ width: '100%' }} onClick={() => ShowBetSlipBox('Harup Andar', `${num}`)}>
                                            {num}
                                        </button>
                                        <span className="btn" style={{ width: '100%' }}></span>
                                    </div>
                                ))}
                                <h5 className="col-12 col-md-12 mb-2 " style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>Harup Bahar</h5>
                                {Single.map((num) => (
                                    <div className="col-4 col-md-3 mb-2">
                                        <button className="btn btn-info" style={{ width: '100%' }} onClick={() => ShowBetSlipBox('Harup Bahar', `${num}`)}>
                                            {num}
                                        </button>
                                        <span className="btn" style={{ width: '100%' }}></span>
                                    </div>
                                ))}
                            </div>

                        </div>

                    </div>

                </div>

                <div className="right-bet-inner">
                    <div id="MatchUnMatchBetaData">
                        <div id="accountView" role="main">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="balance-panel-body">
                                <div className="table-responsive sports-tabel">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr className="heading_user_table" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                                                <td>Team</td>
                                                <td>Mode</td>
                                                <td>Num</td>
                                                <td>Rate</td>
                                                <td>Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lotteryBets.map((row, index) => (
                                                <tr className="heading_user_table">
                                                    <td style={{color:'black'}}>{row.Runner}</td>
                                                    <td style={{color:'black'}}>{row.Mode}</td>
                                                    <td style={{color:'black'}}>{row.Num}</td>
                                                    <td style={{color:'black'}}>{row.Rate}</td>
                                                    <td style={{color:'black'}}>{row.Amount}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <input name="UserType" id="UserType" type="hidden" value={UserType} />
            <input name="UserName" id="UserName" type="hidden" value={UserName} />
            <input name="LotteryMinAmount" type="hidden" id="LotteryMinAmount" value="10" />
            <input name="LotteryMaxAmount" type="hidden" id="LotteryMaxAmount" value="2000" />
            
            <div id="betSidenav" className="betsidenav">
                <a className="closebtn">x</a>
                <section className="right-bet-content">
                    <div></div>
                    <div className="betSlipBox" id="betSlipBox" style={{ display: 'none' }}>
                        <div className="betBox bet-slip-box">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="lds-dual-ring  loader" style={{ display: 'none' }}></div>
                            <div className="bet-box_inner" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                                    <div style={{ fontWeight: '700' }}>BET <span id="BetTypeWithNum"></span></div>
                                    <input type="hidden" id="BetType" name="BetType" />
                                    <input type="hidden" id="BetNo" name="BetNo" />
                                    
                                </div>
                                <div className="inner-bet-section">
                                    <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                        <div className="items stake">
                                            <div className="stack_input_field numbers-row">
                                                <input type="text" id="LotteryAmount" pattern="[0-9]*" step="1" className="calProfitLoss stake-input form-control  CommanBtn" value={inputValue} onChange={handleInputChange} />
                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bet-box-footer">
                                        <button className="btn cancle-bet" type="button" onClick={ResetBet}>Reset</button>
                                        <button className="btn cancle-bet" type="button" onClick={BackBet}>Back</button>
                                        <button className="btn place-bet" type="button" id="cmdDone" name="cmdDone" onClick={handlePlaceBet}>Place Bet</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </section>
            </div>

            <div className="betSlipBox mobile-bet-box" style={{ position: 'fixed', bottom: '0px', zIndex: '999', display: 'none' }} id="betSlipBoxMob">
                <div className="betBox bet-slip-box">
                    <span id="msg_error"></span>
                    <span id="errmsg"></span>
                    <div className="lds-dual-ring  loader" style={{ display: 'none' }}></div>
                    <div className="bet-box_inner bet-box-inner-mobile" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                            <div style={{ fontWeight: '700' }}>BET <span id="BetTypeWithNumMob"></span></div>
                            <input type="hidden" id="BetTypeMob" name="BetTypeMob" />
                            <input type="hidden" id="BetNoMob" name="BetNoMob" />
                        </div>
                        <div className="inner-bet-section">
                            <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                <div className="items odds">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" disabled="" className="calProfitLoss odds-input form-control  CommanBtn" value="" />
                                    </div>
                                </div>
                                <div className="items stake">
                                    <div className="stack_input_field numbers-row">
                                        <input type="text" id="LotteryAmountMob" pattern="[0-9]*" step="1" className="calProfitLoss stake-input form-control  CommanBtn" value={inputValue} onChange={handleInputChange} />
                                        <div className="inc plus_btn">
                                            <span className="plus_btns">+</span>
                                            <div className="quantity-button quantity-up">
                                                <i className="fas fa-plus"></i>
                                            </div>
                                        </div>
                                        <div className="dec plus_btn">
                                            <span className="minus_btns">-</span>
                                            <div className="quantity-button quantity-down">
                                                <i className="fas fa-minus"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bet-box-footer">
                                <button className="btn cancle-bet" type="button" onClick={ResetBet}>Reset</button>
                                <button className="btn cancle-bet" type="button" onClick={BackBet}>Back</button>
                                <button className="btn place-bet" type="button" id="cmdDone" name="cmdDone" onClick={handlePlaceBet}>Place Bet</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default MatkaBet;
